import React from 'react'
import { colors } from 'theme/colors'

export const PhoneIcon = ({size = [21, 20], color = colors.primary.main}) => (
<svg width={size[0]} height={size[1]} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.125 17.8333H5.79167C4.87119 17.8333 4.125 17.0871 4.125 16.1667V2.83333C4.125 1.91286 4.87119 1.16667 5.79167 1.16667H14.125C15.0455 1.16667 15.7917 1.91286 15.7917 2.83333V16.1667C15.7917 17.0871 15.0455 17.8333 14.125 17.8333ZM5.79167 2.83333V16.1667H14.125V2.83333H5.79167ZM9.95833 15.3333C9.4981 15.3333 9.125 14.9602 9.125 14.5C9.125 14.0398 9.4981 13.6667 9.95833 13.6667C10.4186 13.6667 10.7917 14.0398 10.7917 14.5C10.7917 14.9602 10.4186 15.3333 9.95833 15.3333Z" 
fill={color}/>
</svg>

)